import { render, staticRenderFns } from "./misc-table.vue?vue&type=template&id=0b8e40ee&scoped=true&"
import script from "./misc-table.vue?vue&type=script&lang=js&"
export * from "./misc-table.vue?vue&type=script&lang=js&"
import style0 from "./misc-table.vue?vue&type=style&index=0&id=0b8e40ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e40ee",
  null
  
)

export default component.exports